import {
  ArraySignatures,
  FixMe,
  Project,
} from '@greenkub-fronts/shared/interface';
import {
  GKToggleableInput,
  GKToggleableTextArea,
  Icon,
  IconEnum,
} from '@greenkub-fronts/shared/ui';
import cx from 'classnames';

import styles from './mandat-gestion.module.scss';
import templateStyles from '../base-template.module.scss';
import mainStyles from '../../document-signature-container/document-signature-container.module.scss';
import bdcStyles from '../bdc/bdc.module.scss';

import { DATE_FORMAT, DateFromString } from '@greenkub-fronts/shared/utils';
import { DateTime } from 'luxon';

export interface MandatGestionProps {
  project: Project;
  isSignature: boolean;
  signature: FixMe;
  signatures: ArraySignatures;
  handleOpenModalSignHandler: (e: FixMe) => void;
  sign1Ref: FixMe;
  lastName: string;
  setLastName: (value: string) => void;
  firstName: string;
  setFirstName: (value: string) => void;
  setBody: (value: string) => void;
  body: string;
  date: DateTime;
}

const MandatGestion = (props: MandatGestionProps) => {
  const {
    project,
    isSignature,
    signature,
    signatures,
    handleOpenModalSignHandler,
    sign1Ref,
    lastName,
    setLastName,
    firstName,
    setFirstName,
    setBody,
    body,
    date,
  } = props;

  return (
    <div
      className={cx(
        mainStyles['LandingPage'],
        styles['MandatGestion'],
        mainStyles['pages-container']
      )}
    >
      <div
        className={cx(
          mainStyles['LandingPage-page'],
          templateStyles['Template'],
          styles['page']
        )}
      >
        <div
          className={cx(
            templateStyles['Template-head'],
            styles['MandatGestion-head']
          )}
        >
          <Icon
            name={IconEnum.LOGO}
            className={styles['Doc-Signature-head-logo']}
            width="300"
          />
          <h1>
            Contrat de mandat de gestion des démarches administratives pour le
            compte d'un tiers
          </h1>
        </div>

        <div
          className={cx(
            templateStyles['Template-content'],
            styles['MandatGestion-content']
          )}
        >
          <div className={styles['NameLine']}>
            <p>
              Je soussigné(e)&nbsp;
              {isSignature ? (
                <span>{lastName}&nbsp;</span>
              ) : (
                <GKToggleableInput
                  value={lastName}
                  onChange={(value: string) => setLastName(value)}
                  className={'mr5'}
                />
              )}
              {isSignature ? (
                <span>{firstName}</span>
              ) : (
                <GKToggleableInput
                  value={firstName}
                  onChange={(value: string) => setFirstName(value)}
                />
              )}
            </p>
          </div>
          {isSignature ? (
            <p className={styles['BodyLine']}>{body}</p>
          ) : (
            <GKToggleableTextArea
              value={body}
              onChange={(value: string) => setBody(value)}
              className={styles['BodyInput']}
            />
          )}
        </div>

        <div
          className={cx(
            templateStyles['Template-middle'],
            styles['MandatGestion-middle']
          )}
        >
          <div
            className={cx(
              templateStyles['Template-signature'],
              styles['MandatGestion-signature']
            )}
          >
            <span>
              Fait à {project?.address.city} le&nbsp;
              {isSignature ? (
                <>{DateFromString(date.toString(), DATE_FORMAT.SLACH_DATE)}</>
              ) : (
                '<date de signature>'
              )}
            </span>

            <span>Signature</span>

            {isSignature &&
              (signatures[0] === true ? (
                <p
                  className={cx(
                    templateStyles['Template-signed'],
                    styles['MandatGestion-signed']
                  )}
                >
                  {signature}
                </p>
              ) : (
                <div
                  ref={sign1Ref}
                  className={cx(
                    templateStyles['Template-signatureBox'],
                    styles['MandatGestion-signed'],
                    signatures[0] === 'pulse' && bdcStyles['pulse']
                  )}
                  onClick={() => {
                    handleOpenModalSignHandler(0);
                  }}
                >
                  <span>Cliquez ici pour apposer votre signature</span>
                </div>
              ))}
          </div>
        </div>

        <div className={templateStyles['Template-foot']}>
          <p>
            SAS Greenkub - RCS N° 798802377 au capital de 1 249 731,29 Euros - TVA
            N° FR27798802377
          </p>
          <p>
            300 Avenue de la Royale 34160 Castries - France - Tel&nbsp;: 09 74
            59 41 72
          </p>
        </div>
      </div>
    </div>
  );
};

export default MandatGestion;
